import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender } from './Icon';

const ViewIntersectSlashIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>((props, ref) => (
  <Icon data-testid="viewIntersectSlash" ref={ref} {...props}>
    <path d="M15,6.51H9.21a3.759,3.759,0,0,0-3.75,3.75V16H5a2.25,2.25,0,0,1-2.25-2.25V6.05A2.25,2.25,0,0,1,5,3.8h9.79a2.252,2.252,0,0,1,1.9,1l1.07-1.07a3.759,3.759,0,0,0-3-1.48H5a3.761,3.761,0,0,0-3.75,3.8v7.69a3.761,3.761,0,0,0,2.91,3.65Zm4,0h-.45l2-2a.748.748,0,0,0,.174-.243.757.757,0,0,0,.01-.586.746.746,0,0,0-.415-.415.757.757,0,0,0-.586.01.748.748,0,0,0-.243.174l-16,16a.741.741,0,0,0,0,1.06.7.7,0,0,0,.242.166.709.709,0,0,0,.288.054.735.735,0,0,0,.53-.22l1.2-1.21a3.73,3.73,0,0,0,3.46,2.4H19A3.76,3.76,0,0,0,22.75,18V10.26A3.759,3.759,0,0,0,19,6.51ZM21.25,18A2.251,2.251,0,0,1,19,20.2H9.21A2.259,2.259,0,0,1,7,18.09l.6-.6h7.22a3.759,3.759,0,0,0,3.75-3.75V8H19a2.25,2.25,0,0,1,2.25,2.25Z" />
  </Icon>
)) as IconWithRender;

ViewIntersectSlashIcon.displayName = 'ViewIntersectSlashIcon';
ViewIntersectSlashIcon.renderIcon = (props) => (
  <ViewIntersectSlashIcon {...props} />
);
export default ViewIntersectSlashIcon;
